import React from 'react';
import Link from 'redux-first-router-link';
import { hot } from 'react-hot-loader';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { purifier } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { restrictedType } from '../../../utils/restrict';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content, setup, attrs = {}, column = 'full', extraProps = null, imageWidth = false, isPuffContent = false, lazyLoad = true, innerColumnsContent = false, mainImageDepth = false }) => {
	let Wrapper = ({ children }) => children;

	const style = {};
	if (attrs.align) style.textAlign = attrs.align;

	const restrictType = restrictedType(setup, attrs);
	const imageClasses = [s.image, 'u_image'];
	if (restrictType) imageClasses.push(s[`image__${restrictType}`]);
	if (attrs.align === 'full') imageClasses.push(s.image__full);
	if (isPuffContent && /\.svg$/.test(content.image.url)) imageClasses.push(s.image__svgPuff);
	if (innerColumnsContent !== false && mainImageDepth !== innerColumnsContent) imageClasses.push(s.image__minorImage);

	if (attrs?.href) {
		const link = cleanInternalLinks(attrs.href);
		const externalLink = /^(https?|mailto|tel)/.test(link);
		const anchorLink = /^#/.test(link);


		if (attrs.target || externalLink || anchorLink) {
			Wrapper = ({ children }) => <a className={[s.imageLink, 'u_image'].join(' ')} href={attrs.href} target="_blank" rel="noopener noreferrer">{ children }</a>;
		} else {
			Wrapper = ({ children }) => <Link className={[s.imageLink, 'u_image'].join(' ')} to={attrs.href}>{ children }</Link>;
		}
	}

	return (
		<Wrapper>
			<figure className={imageClasses.join(' ')} style={style}>
				<LazyImage className={s.image_image} {...imageSizeTranslation(column, content.image, '-', lazyLoad, false, imageWidth)} {...extraProps} />
				{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
			</figure>
		</Wrapper>
	);
};

export default hot(module)(Image);
